import { render, staticRenderFns } from "./WorkFloCallPrompt.vue?vue&type=template&id=4731b3c8&"
import script from "./WorkFloCallPrompt.vue?vue&type=script&lang=js&"
export * from "./WorkFloCallPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports